import { createSelector } from 'reselect'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import {
  getNewCommentsUtil,
  getReportCommentsUtil
} from 'modules/comments/utils'
import getUserSelector from 'modules/users/selectors/get-user'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { COMMENTS_DOMAIN } from 'modules/comments/constants'
import getInstancesFromDomainMapReduxUtil from 'modules/redux/utils/legacy/get-instances-from-domain-map'
import { getObjectUtil } from 'packages/src'

/**
 * Selects the new `Comment` for the current `Instance`.
 * @returns {Selector}
 */
function getNewCommentSelector () {
  return createSelector(
    state => state && state.comments,
    getInstanceSectionSelector(),
    (
      comments,
      instance
    ) => getNewCommentsUtil(comments, instance)
  )
}

/**
 * Gets the comments of the active instance.
 * @returns {Selector}
 */
function getInstanceCommentsSelector () {
  return createSelector(
    (state, props) => props.route,
    (state, props) => props.match,
    state => state && state.comments,
    (state, props) => getObjectUtil(props.instance, 'data.comments') || [],
    (route, match, comments, instanceComments) => {
      // const { section } = route
      // Get the `domainMapKey` and `domainMapValue`
      // const domainPath = getDomainPathFromSectionReduxUtil(section)
      // const domainMapKey = getDomainMapKeyFromPathReduxUtil(domainPath)
      // const domainMapValue = match.params[domainMapKey]
      // const domainListKeyPath = `${section}.${domainMapValue}`
      return getInstancesFromDomainMapReduxUtil(comments.data, instanceComments.map(getIdReduxUtil).reverse())
      // return getInstancesDomainUtil(comments, domainListKeyPath)
    }
  )
}

/**
 * Selects the `Comments` of the given `Comment`.
 * @returns {Selector}
 */
function getCommentsSelector () {
  return createSelector(
    state => state && state.comments,
    (state, props) => getIdReduxUtil(props.instance),
    (state, props) => getObjectUtil(props.instance, 'data.comments') || [],
    (comments, instanceId, instanceComments) => {
      // If it's a `Comment` which is a reply to another `Comment`, noop
      // NOTE: Otherwise this would cause an infinite loop
      if (instanceComments.length) {
        return []
      }
      // Get the `Comment` ids
      const commentIds = getObjectUtil(
        comments, `${COMMENTS_DOMAIN}.${instanceId}.data`
      )
      // Get the `Comment`s
      return getInstancesFromDomainMapReduxUtil(comments.data, commentIds)
    }
  )
}

/**
 * Selects the `Comment`'s author.
 * @returns {Selector}
 */
function getUserCommentSelector () {
  return createSelector(
    (state, props) => getUserSelector(
      getObjectUtil(props.instance, 'data.user.data.name')
    )(state),
    (
      user
    ) => user
  )
}

/**
 * Selects whether the given `Comment`
 * was reported by the current user.
 * @returns {boolean}
 */
function isReportedByCurrentUserSelector () {
  return createSelector(
    (state, props) => props.instance,
    state => state && state.reports,
    getCurrentUserSelector(),
    (
      comment,
      reports,
      currentUser
    ) => !!getReportCommentsUtil(comment, reports, currentUser)
  )
}

export {
  getNewCommentSelector,
  getUserCommentSelector,
  getInstanceCommentsSelector,
  getCommentsSelector,
  isReportedByCurrentUserSelector
}
